import { render } from "./CreateSnapshotFromVMSnapshot.vue?vue&type=template&id=405f499d&scoped=true"
import script from "./CreateSnapshotFromVMSnapshot.vue?vue&type=script&lang=js"
export * from "./CreateSnapshotFromVMSnapshot.vue?vue&type=script&lang=js"

import "./CreateSnapshotFromVMSnapshot.vue?vue&type=style&index=0&id=405f499d&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405f499d"]])

export default __exports__